export const API_URL = {
  /* START: auth service */
  // auth
  signin: "/authentication-service/v1/login",
  signup: "/authentication-service/v1/registration", // company name & email same dileo error message deyna
  forgotPassword: "/authentication-service/v1/forget-passwrod",
  resetPassword: "/authentication-service/v1/change-password",
  getLocation: "/authentication-service/v1/location", //   geo vul ase
  updateCompleteProfile: "/authentication-service/v1/employee-profile-complete",

  /* START: employee service */
  // department
  getDepartments: "/departments/v1/data",
  getDepartmentDetails: "/departments/v1/details",
  addDepartment: "/departments/v1/create",
  updateDepartment: "/departments/v1/update",
  updateDepartmentStatus: "/departments/v1/department-status-update",

  //approval matrix
  getBusinessUnitList: "/business-unit/v1/all",
  getDepartmentList: "/departments/v1/all",
  getApprovalMatrixList: "/approval-matrix/v1/all",
  getApprovalMatrixDetails: "/approval-matrix/v1/get-by-id",
  addApprovalMatrix: "/approval-matrix/v1/create",
  updateApprovalMatrix: "/approval-matrix/v1/create",
  updateApprovalMatrixStatus: "/approval-matrix/v1/update-status",

  // designation
  getDesignations: "/business-role/v1/data", // search kaj korena
  getDesignationDetails: "/business-role/v1/details",
  addDesignation: "/business-role/v1/create",
  updateDesignation: "/business-role/v1/update",
  updateDesignationStatus: "/business-role/v1/business-role-status-update",

  // employee
  getEmployees: "/employee-management/v1/data", // search, department filter kaj korena
  getEmployeeDetails: "/employee-management/v1/details",
  addEmployee: "/employee-management/v1/create",
  updateEmployeeOfficialData: "/employee-management/v1/update-official-data",
  updateEmployeePersonalData: "/employee-management/v1/update-personal-data",
  updateEmployeeFinancialData: "/employee-management/v1/update-financial-data",
  updateEmployeeSalaryData: "/employee-management/v1/update-salary-data", // *-
  updateEmployeeEmergencyContact:
    "/employee-management/v1/update-emergency-contact",
  updateEmployeeAdditionalData:
    "/employee-management/v1/update-additional-data", // Error ase
  updateEmployeeStatus: "/employee-management/v1/employee-status-update",
  sendInvite: "/employee-management/v1/invite-with-email",
  uploadEmployeeBkashData:
    "/employee-management/v1/create-or-update-bkash-data-of-employee", // error ase
  uploadPhotoInEmployee: "/employee-management/v1/update-photo",

  // employee additional field
  getEmployeeAdditionalFields: "/employee-additional-field/v1/data",
  getEmployeeAdditionalFieldDetails: "/employee-additional-field/v1/details", // *-
  addEmployeeAdditionalField: "/employee-additional-field/v1/create", // only admin er create hoy
  updateEmployeeAdditionalField: "/employee-additional-field/v1/update",
  getAdditionalData: "/employee-additional-field/v1/additional-section",

  /* START: Holiday service */
  getHolidays: "/business-holiday/v1/data",
  getGlobalHolidays: "/business-holiday/v1/global-data",
  getHolidaysByDate: "/business-holiday/v1/get-holiday-by-date-to-date",
  getHolidayDetails: "/business-holiday/v1/details",
  addHoliday: "/business-holiday/v1/create",
  updateHoliday: "/business-holiday/v1/update",
  importGlobalHoliday: "/business-holiday/v1/import-global",

  /* START: Business Shift service */
  getBusinessShifts: "/business-shift/v1/data",
  getBusinessShiftDetails: "/business-shift/v1/details",
  addBusinessShift: "/business-shift/v1/create", // create hoyna
  updateBusinessShift: "/business-shift/v1/update", // update hoyna
  updateBusinessShiftStatus: "/business-shift/v1/shift-status-update",

  /* START: Shift Assign To Employee */
  getShiftCalender: "/shift-assign/v1/shift-calender",
  assignToShift: "/shift-assign/v1/assign-shift",
  assignGeneralAttendance: "/shift-assign/v1/assign-general-attendance",
  unAssigned: "/shift-assign/v1/assign-shift",
  getShiftCartData: "/shift-assign/v1/dashboard-cart",

  /* START: Expense Service */
  expenseEmployee: "/expense/v1/expense-list-monthly-by-admin",
  expenseMonthlyDetails: "/expense/v1/expense-list-by-employee",
  expenseUpdate: "/expense/v1/update-by-admin",
  expenseAccept: "/expense/v1/accept-expense",
  expenseReject: "/expense/v1/reject-expense",
  getExpenseReportExcel: "/expense/v1/expense-report-excel",
  getExpenseReportDetailsExcel: "/expense/v1/expense-details-report-excel",

  /* START: Announcement Service */
  createAnnouncement: "/announcement/v1/create",
  getAnnouncementList: "/announcement/v1/data",
  getAnnouncementDetails: "/announcement/v1/details",
  updateAnnouncement: "/announcement/v1/update",

  /* START: Attendance Setting */
  getAttendanceSettingData: "/attendance-setting/v1/data",
  addAttendanceSetting: "/attendance-setting/v1/create",

  /* START: Operational Setting */
  getOfficeSettingData: "/operational-setting/v1/data",
  addOfficeSetting: "/operational-setting/v1/create",

  /* START: Attendance Report */
  getDailyAttendanceReport: "/attendance/v1/daily-attendace-report",
  getCustomAttendanceReport: "/attendance/v1/custom-attendace-report",
  getCustomAttendanceByEmployee:
    "/attendance/v1/custom-attendace-report-by-employee",

  /* START: Leave Type */
  getLeaveTypeList: "/leave-type/v1/data",
  updateLeaveType: "/leave-type/v1/update",
  addLeaveType: "/leave-type/v1/create",

  /* START: Leave Prorate */
  addOtherSetting: "/leave-prorate/v1/create",
  getOtherSetting: "/leave-prorate/v1/get-leave-setting-other-data",
  addLeaveProrateManually: "/leave-prorate/v1/create",
  addLeaveAutoProrateRun: "/leave-prorate/v1/auto-prorate-run",
  getLeaveProrateDetails: "/leave-prorate/v1/employee-prorate-logs",
  updateLeaveProrate: "/leave-prorate/v1/prorate-update",
  getLeaveType: "/leave-type/v1/data",
  getLeaveTypeById: "/leave-type/v1/leave-type-details",

  /* START: Leave Application */
  addLeaveApplication: "/leave-application/v1/create",
  updateLeaveApplication: "/leave-application/v1/update",
  getLeaveApplicationList: "/leave-application/v1/data",
  getLeaveApplicationDetails: "/leave-application/v1/leave-application-details",
  updateLeaveApplicationApproved:
    "/leave-application/v1/leave-application-status-update",
  updateLeaveApplicationReject:
    "/leave-application/v1/leave-application-status-update",
  updateLeaveApplicationCancel:
    "/leave-application/v1/leave-application-status-update",
  getLeaveProrateEmployeeList: "/leave-prorate/v1/leave-prorate-employee-list",
  getEmployeeProrateList: "/leave-prorate/v1/employee-prorate-list",
  deleteLeaveProrate: "/leave-prorate/v1/prorate-delete",
  getLeaveBalance: "/leave-prorate/v1/leave-balance",
  getLeaveBalanceDetails: "/leave-prorate/v1/leave-balance-details",

  // portal

  // vendor payment start
  getAllVendorBatch: "/vendor-payments/v1/unique-disbursement-batches",
  createVendor: "/vendor-payments/v1/create",
  getAllVendor: "/vendor-payments/v1/get-all",
  getSingleVendor: "/vendor-payments/v1/get-single",
  vendorPaymentChecker: "/vendor-payments/v1/checker",
  vendorPayment: "/vendor-payments/v1/vendor-to-merchant",

  // disbursements payment start
  createDisbursements: "/salary-disbursements/v1/create",
  getAllDisbursements: "/salary-disbursements/v1/get-all",
  getSingleDisbursements: "/salary-disbursements/v1/get-single",
  disbursementsPayment: "/salary-disbursements/v1/disburse-salary",
  disbursementsPaymentChecker: "/salary-disbursements/v1/checker",
  getAllDisbursementBatch:
    "/salary-disbursements/v1/unique-disbursement-batches",
  disbursementsPaymentWithOtp: "/salary-disbursements/v1/disburse-salary",
  checkButtonForSalaryDisbursmentStatus:
    "/salary-disbursements/v1/check-approver-pending",
  getAllVendors: "/vendor-payments/v1/get-all",
  vendorPaymentsSentToChecker: "/vendor-payments/v1/checker",
  vendorsPaymentWithOtp: "/vendor-payments/v1/vendor-to-merchant",
  checkButtonForVendorPaymentsStatus:
    "/vendor-payments/v1/check-approver-pending",
  disburesementRetryable: "/salary-disbursements/v1/is-disburs-retryable",

  // user start
  createUser: "/users/v1/create-user",
  getSingleUser: "/users/v1",
  getAllUsers: "/users/v1/get-all",
  updateSingleUser: "/users/v1/update",
  // firstTimeLogin: "/users/v1/first-time-login",
  firstTimeLogin: "/users/v1/create-user-not-in-db",
  getMe: "/users/v1/get/my-data",
  updateResetPassword: "/users/v1/other/user/reset-password",
  updateOwnPassword: "/users/v1/update-password",
  getDashboardData: "/users/v1/dashboard/get-dashboard-data",
  getUserLogData: "/users/v1/get/my-logs",
  updateUserStatus: "/users/v1/keycloak/status",
  getUserStatus: "/users/v1/keycloak/status/email",
  createUserIfNotExist: "/users/v1/create-user-not-in-db",

  // company on board
  createCompany: "/company/v1/create",
  getAllCompany: "/company/v1/get-all",
  getSingleCompany: "/company/v1/get-single",
  updateCompany: "/company/v1",
  updatePin: "/company/v1/update-of",
  updateWallet: "/company/v1/update-source-wallet-data",
  assignProject: "/company/v1/grant-project-access",
  getAllAssignProject: "/company/v1/accessible-projects",
  getCompanyWallet: "/company/v1/company-wallet",

  balanceCheck: "/vendor-payments/v1/balance-check",
  otpRequest: "/otp/v1/send-otp-request",
  verifyOtp: "/otp/v1/verify-otp",
  verifyPin: "/otp/v1/validate-pin",
  otpRequestTime: "/otp/v1/get-otp-request-time",
  createWalletTag: "/wallet-tags/v1/tags/create",
  getAllWalletTag: "/wallet-tags/v1/tags/data",
  getSingleWalletTag: "/wallet-tags/v1/tags/get-by-id",
  updateWalletTag: "/wallet-tags/v1/tags/update",
  deleteWalletTag: "/wallet-tags/v1/tags/delete",

  // Wallet APIs
  createWallet: "/wallet-tags/v1/wallet/create",
  getAllWallet: "/wallet-tags/v1/wallet/data",
  getSingleWallet: "/wallet-tags/v1/wallet/get-by-id",
  updateWalletV2: "/wallet-tags/v1/wallet/update",
  getSingleUserWalletRole: "/wallet-tags/v1/wallet-user-role",

  // User Wallet Role
  assignUserWalletRole: "/wallet-tags/v1/user-role/assign",
  updateUserWalletRole: "/wallet-tags/v1/user-role/update",
  getUserWalletRoleById: "/wallet-tags/v1/wallet",
  getUserWalletRoleByUserId: "/wallet-tags/v1/user",
  getUsersWithDisbursementAccess:
    "/users/v1/disbursement-project-users/disbursement",

  vendorPaymentWithOtp: "/vendor-payments/v1/vendor-to-merchant",
  vendorAmount: "/vendor-payments/v1/count-by-status",
  salaryAmount: "/salary-disbursements/v1/count-by-status",
  checkVendorDisbursement: "/vendor-payments/v1/batch-status-check",
  checkSalaryDisbursement: "/salary-disbursements/v1/batch-status-check",
  sentToChecker: "/salary-disbursements/v1/sent-to-checker",
  batchReject: "/salary-disbursements/v1/bulk-batch-reject",
  sentToCheckerVendor: "/vendor-payments/v1/sent-to-checker",
  batchRejectVendor: "/vendor-payments/v1/bulk-batch-reject",

  // file upload
  uploadFile: "/employee-management/v1/update-photo",

  // Products
  createProduct: "/project-master/v1/create-keycloak-client",
  updateProduct: "/project-master/v1/project-master",
  getAllProduct: "/project-master/v1/project/get-all",
  getSingleProduct: "/project-master/v1/project",
  userProduct: "/project-master/v1/users/user-project-ids",
  checkUserBelongProject: "/project-master/v1/users/check-project-belongs",
  userCompanyCount: "/project-master/v1/user-company-counts",
  userActiveInactiveRole: "/project-master/v1/user/active-inactive-role",
  deleteProductFeature: "/project-master/v1/project-master",
  // User Get
  getUserList: "/project-master/v1/project",

  // Role Management
  createRole: "/project-master/v1/role/create-role",
  getAllRole: "/project-master/v1/role/all",
  getSingleRole: "/project-master/v1/role",
  assignUserToProjectRole: "/project-master/v1/user/assign-role",
  getUsersByProjectRole: "/project-master/v1/users/by-project",
  getProjectsByUser: "/project-master/v1/projects/by-user",
  createUserPool: "/user-pool/v1/create",
  getUserPoolByWalletId: "/user-pool/v1/pool-by-wallet",
  getUserPoolProject: "/user-pool/v1/user-pool-by-project",
  deleteUserPool: "/user-pool/v1/remove",

  // Work Flow
  createWorkFlow: "/workflow-rule/v1/create",
  getAllWorkFlow: "/workflow-rule/v1/get-all",
  getSingleWorkFlow: "/workflow-rule/v1",
  updateWorkFlow: "/workflow-rule/v1/data/update",

  // Batch
  createBatch: "/batch/v1/create",
  getAllBatch: "/batch/v1/get-all",
  getSingleBatch: "/batch/v1",
  updateBatch: "/batch/v1/update",
  updateBatchName: "/batch/v1/update-name",
  getBatchLog: "/batch/v1/by-batch",
  getUserPerformBatch: "/batch/user-batch-data",
  createBatchVendor: "/batch/v1/vendor-batch/create",
  getAllBatchVendor: "/batch/v1/batches-vendor",
  createBatchForDigigo: "/batch/v1/create-batch-for-digigo",
  getAllBatchPendingList: "/batch/v1/pending-list",
  pendingBatchBulkAction: "/batch/v1/pending-list/bulk-action",
  batchRejectByMaker: "/batch/v1/reject-batch",
  createDisbursementType: "/batch/v1/disbursement-type",
  getAllDisbursementType: "/batch/v1/disbursement-type/all",

  // Statements
  bankRequest: "/bank-statement/v1/request",
  getAllStatements: "/bank-statement/v1/get-all",
  getDownloadStatements: "/bank-statement/v1/download",
  getBankStatementsDownload: "/bank-statement/v1/download-sync",

  // Settings
  createPortalDepartment: "/departments/v1/create",
  updatePortalDepartment: "/departments/v1/update",
  updatePortalStatusDepartment: "/departments/v1/department-status-update",
  getProtalAllDepartment: "/departments/v1/data",
  getProtalSingleDepartment: "/departments/v1/details",
  createPortalSubDepartment: "/sub-departments/v1/create",
  updatePortalSubDepartment: "/sub-departments/v1/update",
  updatePortalStatusSubDepartment: "/sub-departments/v1/update",
  getProtalAllSubDepartment: "/sub-departments/v1/list",
  getProtalSingleSubDepartment: "/sub-departments/v1/details",
  getPortalSingleSubDepartmentById: "/sub-departments/v1/get-by-department",

  // PG-RUN API
  getAllPGVendor: "/power-genie/v1/vendors",
  getAllPGRegion: "/power-genie/v1/regions",
  getAllPGArea: "/power-genie/v1/areas",
  getAllPGTerritories: "/power-genie/v1/territories",

  // Workstation
  getWorkStations: "/work-stations/v1/data",
  getWorkStationDetails: "/work-stations/v1/details",
  addWorkStation: "/work-stations/v1/create",
  updateWorkStation: "/work-stations/v1/update",
  updateWorkStationStatus: "/work-stations/v1/work-station-status-update",

  // Expense Unit
  getExpenseUnits: "/business-unit/v1/data",
  getExpenseUnitDetails: "/business-unit/v1/details",
  addExpenseUnit: "/business-unit/v1/create",
  updateExpenseUnit: "/business-unit/v1/update",
  updateExpenseUnitStatus: "/business-unit/v1/business-unit-status-update",

  // Administrative Setting
  getProjectWiseModule: "/administrative-setting/v1/project-module/data",

  createPermission: "/administrative-setting/v1/group-permission/create",
  updatePermission: "/administrative-setting/v1/group-permission/update",
  updateBulkStatusPermission:
    "/administrative-setting/v1/group-permission/bulk-status-update",
  getAllPermission: "/administrative-setting/v1/group-permission/data",
  getPermissionDetails: "/administrative-setting/v1/group-permission/details",
  deletePermission: "/administrative-setting/v1/group-permission/delete",

  groupPermissionAssign:
    "/administrative-setting/v1/group-permission/assign-users",
  groupPermissionUpdate:
    "/administrative-setting/v1/group-permission/replace-user-permissions",
  groupPermissionRemove:
    "/administrative-setting/v1/group-permission/remove-users",
  getAllUserPermissionId:
    "/administrative-setting/v1/group-permission/permission",
  getAllGroupByUserId: "/administrative-setting/v1/group-permission/user",
  getLogByUserId: "/administrative-setting/v1/group-permission/user-logs",
};

export const BASE_API_BSRM = {
  // Auth
  login: "/user/login",

  // Dashboard
  // getOverview: "/report/v1/dashboard/overview",
  getTopDealers: "/report/v1/dashboard/top-dealers",
  // getTransactionsGraph: "/report/v1/dashboard/transactions",
  exportStatement: "/report/v1/supplier-payments/export",
  // getPaymentHistory: "/report/v1/supplier-payments/history",
  // getZoneList: "/report/v2/dashboard/zones",
  // getDistrictList: "/report/v2/dashboard/district",
  // getBusinessUnit: "/report/v2/dashboard/business-units",

  // Dashboard V2
  getOverview: "/report/v1/dashboard/overview",
  getTransactionsGraph: "/report/v1/dashboard/transactions",
  getTopParties: "/report/v1/dashboard/top-parties",
  getPaymentHistory: "/report/v1/supplier-payments/history",
  getZoneList: "/report/v2/dashboard/zones",
  getDistrictList: "/report/v2/dashboard/district",
  getBusinessUnit: "/report/v2/dashboard/business-units",
  getAllSupplierParties: "/report/v2/dashboard/parties",

  // Traders
  getTopTraders: "/report/v2/dashboard/top-traders",
  getTraderList: "/report/v2/dashboard/traders-transaction-history",
  getTradersSummery: "/report/v2/dashboard/traders-summary",

  // Dealers
  getDealerList: "/report/v2/dashboard/distributors",

  // (File Upload)
  fileUpload: `/dealer/v1/file-image-upload`,
};

export const BASE_API_CASH_COLLECTION = {
  // GEO Setup Zone
  createZone: "/geo/zones",
  updateZone: "/geo/zones",
  getAllZone: "/geo/zones",
  getSingleZone: "/geo/zones",

  // GEO Setup Area
  createArea: "/geo/areas",
  updateArea: "/geo/areas",
  getAllArea: "/geo/areas",
  getSingleArea: "/geo/areas",

  // GEO Setup Territory
  createTerritory: "/geo/territories",
  updateTerritory: "/geo/territories",
  getAllTerritory: "/geo/territories",
  getSingleTerritory: "/geo/territories",

  // GEO Setup Route
  createRoute: "/geo/routes",
  updateRoute: "/geo/routes",
  getAllRoute: "/geo/routes",
  getSingleRoute: "/geo/routes",
  virtualAccount: "/geo/routes",
  checkAccountNumberAvailability:
    "cash-collection-sr/virtual-account/eligibility",

  // SR Setup Field Officers
  createSR: "/cash-collection-sr",
  updateSR: "/cash-collection-sr",
  getAllSR: "/cash-collection-sr",
  getSingleSR: "/cash-collection-sr",
  getCashCollection: "/cash-collection-sr/cash-collection",
  statsByUsers: "/cash-collection-sr/stats-by-users",

  // Cash Collection Setup Transactions
  getTransactions: "/cash-collection-sr/cash-collection",
  getTransactionsSummary: "/cash-collection-sr/v1/cash-collection-summary",
  getBankTransactions: "/cash-collection-sr/bank/route-bank-transactions",
  getTransitionDetails: "/cash-collection-sr/cash-collection",
  updateUserForBankId: "/cash-collection-sr/bank/route-bank-transactions",

  // Collection point setup
  createCollectionPoint: "/collection-point",
  updateCollectionPoint: "/collection-point",
  getAllCollectionPoint: "/collection-point",
  getSingleCollectionPoint: "/collection-point",

  // Dashboard setup
  getCashCollectionState1: "/cash-collection-sr/cash-collection-stats",
  getCashCollectionState2: "/cash-collection-sr/sr-count",
  getCashCollectionState3: "/cash-collection-sr/daily-cash-collection-stats",
  getCashCollectionState4: "/collection-point/v1/stats",
};

export const EMP_API = {
  // employee
  getEmployees: "/employee-management/v1/data", // search, department filter kaj korena
  getEmployeeDetails: "/employee-management/v1/details",
  getMe: "/employee-management/v1/details-me",
  addEmployee: "/employee-management/v1/create",
  updateProfilePicture: "/employee-management/v1/update-profile-picture",
  updateEmployeeOfficialData: "/employee-management/v1/update-official-data",
  updateEmployeePersonalData: "/employee-management/v1/update-personal-data",
  updateEmployeeFinancialData: "/employee-management/v1/update-financial-data",
  updateEmployeeSalaryData: "/employee-management/v1/update-salary-data",
  updateEmployeeEmergencyContact:
    "/employee-management/v1/update-emergency-contact",
  updateEmployeeAdditionalData:
    "/employee-management/v1/update-additional-data",
  updateEmployeeStatus: "/employee-management/v1/employee-status-update",
  updateEmployeeBulkStatus:
    "/employee-management/v1/employee-status-bulk-update",
  sendInvite: "/employee-management/v1/invite-with-email",
  uploadEmployeeBkashData:
    "/employee-management/v1/create-or-update-bkash-data-of-employee",
  uploadPhotoInEmployee: "/employee-management/v1/update-photo",
  reInvited: "/employee-management/v1/re-invite-with-email",
  activeInvited: "/employee-management/v1/activate-invite-employee",
  makeCompanyAdmin: "/employee-management/v1/make-company-admin",
  makeHRAdmin: "/employee-management/v1/make-hr-admin",
  makeSuperAdmin: "/employee-management/v1/make-super-admin",
  roleStatus: "/employee-management/v1/role-status",
  deleteRole: "/project-master/v1/user/remove-role",
  deleteInvited: "/employee-management/v1/invitation-delete",
  downloadEmployeeDetails: "/employee-management/v1/download-pdf",
  removeAdditionalData: "/employee-additional-field/remove-additional-data",
  getEmployeesListExport: "/employee-management/v1/employees-list-download",
  getEmployeeManagementData: "/employee-management/v1/data",
  getUserDetailsLog: "/employee-management/v1/setting-logs",
  getGrade: "/employee-management/v1/grades",
  downloadGrossSalary: "/payroll-setting/v1/download-employees-gross-salary",
  uploadGrossSalary: "/payroll-setting/v1/employee-gross-salary",
  uploadAdditionDeductionSalary:
    "/payroll-setting/v1/employee-addition-deduction-salary-by-admin",
  getEmployeeBreakdownSalaryDetails:
    "/payroll-setting/v1/employee-breakdown-salary-details",
  updateSalaryDetails: "/payroll-setting/v1/employee-component-setting",
  uploadVariableSalary: "/payroll-setting/v1/employee-variable-salary-by-admin",
  employeeReport: "/employee-report/v1/download-employee-list",
  getPayrollSetting: "/payroll-setting/v1/get-payroll-setting-data",
  downloadSalaryCertificate:
    "/payroll-setting/v1/download/employee-breakdown-salary-details",
  getEmployeeAdditionalFields: "/employee-additional-field/v1/data",
  getEmployeeAdditionalFieldDetails: "/employee-additional-field/v1/details",
  addEmployeeAdditionalField: "/employee-additional-field/v1/create",
  updateEmployeeAdditionalField: "/employee-additional-field/v1/update",
  getAdditionalData: "/employee-additional-field/v1/additional-section",
  getBusinessData: "/employee-management/v1/business",
  getPayComponentSetting: "/payroll-setting/v1/user-pay-components",
  getDisbursementBankKeywords:
    "/employee-management/v1/disbursement-bank-keywords",
};
